// Normalize entered SSN value in preparation to put the value in the store.
// substr(0, 11) takes only the first 11 characters of the value
// replace(/\D/g, '') removes any characters which are not numeric digits
const normalizeSsn = value => (value ? value.substr(0, 11).replace(/\D/g, '') : '');

export default normalizeSsn;
